import { render, staticRenderFns } from "./WaitOrder.vue?vue&type=template&id=311d41b3&"
import script from "./WaitOrder.vue?vue&type=script&lang=js&"
export * from "./WaitOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports